
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hospitals/[hospitalId]",
      function () {
        return require("private-next-pages/hospitals/[hospitalId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hospitals/[hospitalId]"])
      });
    }
  